/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');
require('../../es.number.constructor-17a0e7eb.js');
require('../../to-string-e5a81da9.js');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: "MqTooltip",
  data: function data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 200
    },
    content: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  methods: {
    showIknow: function showIknow() {
      this.$confirm(this.content, this.title, null, {
        showCancelButton: false,
        sureButtonText: this.$t('iKnow')
      });
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "question_down", staticStyle: { display: "flex" } },
    [
      ["pd", "ph"].includes(_vm.$mq)
        ? _c("div", { on: { click: _vm.showIknow } }, [_vm._t("default")], 2)
        : _c(
            "el-tooltip",
            {
              attrs: {
                tabindex: -1,
                effect: "dark",
                content: _vm.content,
                placement: _vm.placement,
              },
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("div", {
                style: { width: _vm.width + "px" },
                attrs: { slot: "content" },
                domProps: { innerHTML: _vm._s(_vm.content) },
                slot: "content",
              }),
            ],
            2
          ),
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-901e25e6";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
